import { LinkCell, CustomCell } from "./cell";
import { repRiskRatingColDefs, performanceVariationColDefs, getRatingCategoryColDefs } from "./column-definition";
import { repRiskRatingCamelCase } from "common/esg-helpers";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
// eslint-disable-next-line complexity
const getColumnDefs = (source, headerName, linkedEntity) => {
    switch (source) {
        case repRiskRatingCamelCase:
            return repRiskRatingColDefs;
        case "performanceVariation":
            return performanceVariationColDefs;
        case "companyType":
        case "country":
        case "geography":
        case "industries":
        case "industryGroups":
        case "investmentStatus":
        case "investmentYear":
        case "sector":
        case "subIndustries":
        case "industry":
        case "industryGroup":
        case "strategy":
        case "status":
        case "vintage":
        case "company":
        case "apacs":
        case "stage":
        case "currency":
        case "unit":
        case "dealSources":
        case "dealStyle":
        case "controlInDeal":
        case "transactionLeads":
        case "exitStyle":
        case "exitMethods":
        case "dealCoInvestors":
            return getRatingCategoryColDefs("key", headerName || "");
        case "fund":
        case "manager":
            return getRatingCategoryColDefs("key", headerName || "", { cellRenderer: LinkCell, linkedEntity });
        default:
            throw new Error(`${source} not supported`);
    }
};
export const getTableColDefs = (args) => {
    const sourceColDefs = getColumnDefs(args.source, args.options?.sourceHeaderName);
    const groupBySourceColDefs = args.groupBySource ? getColumnDefs(args.groupBySource, args.options?.groupByHeaderName, args.options?.sourceLinkedEntity) : [];
    return groupBySourceColDefs.concat(sourceColDefs);
};
export const getCustomTableColDefs = (tableColumns) => {
    const colDefs = tableColumns.map((column) => ({
        cellClassName: "cell-align-text-right",
        cellRenderer: CustomCell,
        field: column.name,
        format: column.type,
        headerClassName: "cell-align-text-right",
        headerName: column.header,
        width: column.width
    }));
    colDefs.unshift({
        cellClassName: "cell-align-text-left",
        cellRenderer: CustomCell,
        field: "key",
        format: ChartSelectValueFormatKind.string,
        headerClassName: "cell-align-text-right",
        headerName: "",
        width: "100px"
    });
    return colDefs;
};
